module.exports = __webpack_public_path__ + "assets/img/3212.bc84898f.png";